// Orquestrador de Parsers de ERP (Sistema Interno)
// Padrão Factory: cada parser exporta detectar(dadosArray) e processar(dadosArray)
// Novos parsers de ERP devem ser registrados aqui

import * as cardapioWebParser from './cardapioWebParser';
import * as extratoErpParser from './extratoErpParser';

export const detectAndProcessERP = (dadosArray) => {
    const parsers = [
        { nome: 'Cardápio Web', parser: cardapioWebParser },
        { nome: 'Extrato Sistema', parser: extratoErpParser },
    ];

    for (const { nome, parser } of parsers) {
        try {
            if (parser.detectar(dadosArray)) {
                const resultado = parser.processar(dadosArray);
                return { vendas: resultado, nomeERP: nome };
            }
        } catch (e) {
            console.warn(`Parser ERP '${nome}' falhou:`, e.message);
        }
    }

    throw new Error(
        'Formato de relatório interno não reconhecido. ' +
        'Certifique-se de que é um arquivo válido do sistema de vendas do cliente. ' +
        'Caso seja um formato novo, entre em contato com o suporte para adicionar o parser.'
    );
};
